import useSWR from "swr";

import { PagedOrganizationsResponse } from "@organization/models/PagedOrganizationsResponse";

import { organizationEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export default function useGetOrganizationsForFilter(search?: string) {
  const params = new URLSearchParams(search);

  params.append("orderby", "name:asc");

  // Since Apr-2025 For this endpoint if pageSize is omitted, then backend return all records
  // But if pageSize is set for any number it will be used.

  if (search) {
    params.append("search", search);
  }

  const url = organizationEndpoints.search();

  const fetcherWithToken = (url: string) =>
    fetcher<PagedOrganizationsResponse>(url);

  const {
    data: responses,
    error,
    isLoading
  } = useSWR(url + `?${params.toString()}`, fetcherWithToken);

  return {
    organizations: responses?.organizations,
    totalCount: responses?.total,
    isLoading,
    hasError: Boolean(error)
  };
}
